import { Card, Title, Text } from 'components/common'

export interface CustomerMemoProps {
  memo?: string
  loading?: boolean
}

export const CustomerMemo = ({
  memo,
  loading,
}: CustomerMemoProps): JSX.Element => (
  <>
    <Card loading={loading} shadow>
      <Title level={5}>お客様に対するメモ</Title>
      {memo ? (
        <Text>{memo}</Text>
      ) : (
        <Text mute>お客様に対するメモは有りません。</Text>
      )}
    </Card>
  </>
)
